import React from "react";

const NavBar = () =>{
  return(
    <div className="bg-bgDark py-4">
      <nav><h1 className="text-center font-bold text-white">Top courses</h1></nav>
    </div>
  )
}

export default NavBar;